"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TipoNode = void 0;
var TipoNode = /** @class */ (function () {
    function TipoNode() {
        this._id = { no: '', tipo: '' };
        this.NODE = '';
        this.CD_TIPO = '';
        this.DS_TIPO = '';
    }
    return TipoNode;
}());
exports.TipoNode = TipoNode;
//# sourceMappingURL=TipoNode.js.map